import { Outlet } from "react-router-dom";
import { SiteFooter } from "@/shared/layout/SiteFooter";
import { SiteHeader } from "@/shared/layout/SiteHeader";
import FloatingButtons from "../components/FloatingButtos";

export default function AppShell() {
  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />

      <main className="flex-1">
        <Outlet />
      </main>

      <SiteFooter />
      <FloatingButtons />
    </div>
  );
}
